import 'slick-carousel'
const tileBlocks = document.querySelectorAll('.tile-block')

tileBlocks.forEach(function (element, index) {
  if (element.querySelector('.tile-container').children.length > 1){
    let container = element.querySelector('.tile-container')
    $(container).slick({})
  }
})
